{
  "expandButtonOpen": "See details",
  "expandButtonClose": "Hide details"
}
